import type { CartConfig } from '#types/config/components/cart'

export default {
  brandClasses: {
    details: 'body-3',
    progressBar: 'h-2 rounded',
    threshold: 'body-3'
  }
} satisfies CartConfig['shippingProgress']
